import { z } from "zod";
/**
 * Instant ISO 8601 AVEC fuseau explicite — jamais d'heure locale nue.
 * CDC §3.2 : un arrêt peut porter son propre fuseau ; les heures d'un arrêt
 * sont exprimées dans le fuseau de cet arrêt, pas dans un fuseau unique.
 */
export const IsoDateTime = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/, "instant ISO 8601 avec fuseau explicite requis");
/** Identifiant opaque et stable, préfixé par opérateur côté serveur (CDC §6.1). */
export const OpaqueId = z.string().min(1);
export const LonLat = z.tuple([z.number(), z.number()]);
export const BoundingBox = z.tuple([LonLat, LonLat]); // [[minLon,minLat],[maxLon,maxLat]]
export const Position = z.object({
    lat: z.number(),
    lon: z.number(),
    bearing: z.number().min(0).lt(360).nullable(),
});
export const GeoJsonLineString = z.object({
    type: z.literal("LineString"),
    coordinates: z.array(LonLat),
});
export const ApiError = z.object({
    error: z.object({
        code: z.enum([
            "network_unknown",
            "post_forbidden",
            "feature_disabled",
            "source_degraded",
            "not_found",
            "conflict",
            "unauthenticated",
            "validation_failed",
            "pdf_extraction_failed", // D-010 — POST /admin/networks/{n}/pdf-datasets, extraction impossible
            "out_of_scope", // P2 §3 — course hors périmètre décisionnel (croisement, retournement)
        ]),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
});
export const CONTRACT_VERSION = "1.56";
/**
 * Numéro de séquence global du flux (D-009). Monotone, partagé par tous les
 * sujets. Chaque instantané REST porte le `seq` auquel il est cohérent ; chaque
 * delta SSE porte son propre `seq`. Un client qui recharge un instantané après
 * un trou écarte les deltas de `seq` inférieur ou égal.
 */
export const Seq = z.number().int().nonnegative();
//# sourceMappingURL=common.js.map